<script setup>
    //import { Nav, Alert } from '@/components';
    //import { useAuthStore } from '@/stores';
    //const authStore = useAuthStore();

    alert('systems.app.vue')
</script>

<template>
    <div>
        App.vue
    </div>
    <!--<router-view />-->
    <!--<router-view v-slot="{ Component }">
        <transition>
            <keep-alive>
                <component :is="Component" />
            </keep-alive>
        </transition>
    </router-view>-->
</template>